// @ts-check
import { useQuery } from '@tanstack/react-query';
import { getCart } from '../api/services/cartService';

/**
 * Fetches the current user's cart.
 * staleTime=0 ensures the cart is always fresh after mutations.
 * Mutations created in SHOP-05 (useCartMutations) call
 * queryClient.invalidateQueries({ queryKey: ['cart'] }) after every change.
 *
 * Returns null data when the user is not authenticated (the API returns 401,
 * which the axios interceptor handles by redirecting to /login on most pages,
 * but CartPage itself handles the empty state gracefully).
 */
const useCart = () => {
  return useQuery({
    queryKey: ['cart'],
    queryFn: getCart,
    staleTime: 60_000,
    retry: false,
  });
};

export default useCart;
